import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import sweetalert from "sweetalert";
import ApiEnter from "@/api/ApiEnter";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import LeftMenuTab from "@/components/LeftMenu/LeftMenuTab.vue";
import PageHeader from "@/components/UI/PageHeader.vue";
import ApiStores from "@/api/ApiStores";
import DataStores from "@/data/CMS/DataStores";
import dayjs from "dayjs";
let StoresList = class StoresList extends Vue {
    constructor() {
        super(...arguments);
        this.TableHeaders = DataStores.TableHeaders;
        this.Breadcrumbs = DataStores.Breadcrumbs;
        this.TableItems = [];
        this.Search = "";
        this.SyncLoading = false;
        this.FilterRegion = null;
        this.FilterProvince = null;
        this.FilterVisibility = null;
        this.FilterDateFrom = "";
        this.FilterDateTo = "";
        this.VisibilityOptions = [
            { text: "Visible", value: 0 },
            { text: "Hidden", value: 1 },
        ];
    }
    DistinctCaseInsensitive(values) {
        const map = new Map();
        values.forEach(v => {
            if (v && !map.has(v.toLowerCase())) {
                map.set(v.toLowerCase(), v);
            }
        });
        return Array.from(map.values()).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));
    }
    get RegionOptions() {
        return this.DistinctCaseInsensitive((this.TableItems || []).map(i => i.region));
    }
    get ProvinceOptions() {
        return this.DistinctCaseInsensitive((this.TableItems || []).map(i => i.province));
    }
    get FilteredItems() {
        let items = (this.TableItems || []).slice();
        const search = (this.Search || "").toLowerCase().trim();
        if (search) {
            items = items.filter(i => (i.store_name || "").toLowerCase().includes(search) || (i.address || "").toLowerCase().includes(search) || (i.city || "").toLowerCase().includes(search) || (i.pos_code || "").toLowerCase().includes(search));
        }
        if (this.FilterRegion) {
            const region = this.FilterRegion.toLowerCase();
            items = items.filter(i => (i.region || "").toLowerCase() === region);
        }
        if (this.FilterProvince) {
            const province = this.FilterProvince.toLowerCase();
            items = items.filter(i => (i.province || "").toLowerCase() === province);
        }
        if (this.FilterVisibility === 0 || this.FilterVisibility === 1) {
            items = items.filter(i => i.is_hidden === this.FilterVisibility);
        }
        if (this.FilterDateFrom) {
            const from = dayjs(this.FilterDateFrom + " 00:00:00").valueOf();
            items = items.filter(i => dayjs(i.created_at).valueOf() >= from);
        }
        if (this.FilterDateTo) {
            const to = dayjs(this.FilterDateTo + " 23:59:59").valueOf();
            items = items.filter(i => dayjs(i.created_at).valueOf() <= to);
        }
        items.sort((a, b) => {
            if (a.is_hidden !== b.is_hidden)
                return a.is_hidden - b.is_hidden;
            return (a.store_name || "").localeCompare(b.store_name || "", undefined, { sensitivity: "base" });
        });
        return items;
    }
    async SyncNow() {
        this.SyncLoading = true;
        try {
            await ApiStores.RefreshSalesPoints(ApiEnter.CurrentSessionUUID);
            sweetalert({
                title: this.$t("general.success"),
                text: "Sincronizzazione avviata. Il completamento può richiedere alcuni minuti.",
                icon: "success",
            });
        }
        catch (e) {
            console.error(e);
            sweetalert({
                title: this.$t("general.error"),
                text: this.$t("general.request_error"),
                icon: "info",
            });
        }
        this.SyncLoading = false;
    }
    async ChangePublish(item, visible) {
        try {
            const is_hidden = visible ? 0 : 1;
            const response = await ApiStores.ChangeStorePublish(ApiEnter.CurrentSessionUUID, item.uuid, is_hidden);
            if (typeof response == "boolean") {
                sweetalert({
                    title: this.$t("general.success"),
                    text: this.$t("general.success_updated"),
                    icon: "success",
                }).then(() => {
                    this.LoadTable();
                });
            }
            else {
                sweetalert({
                    title: this.$t("general.error"),
                    text: this.$t("general.request_error"),
                    icon: "info",
                });
            }
        }
        catch (e) {
            console.error(e);
            sweetalert({
                title: this.$t("general.error"),
                text: this.$t("general.request_error"),
                icon: "info",
            });
        }
    }
    async LoadTable() {
        try {
            const response = await ApiStores.GetStoresList(ApiEnter.CurrentSessionUUID);
            if (typeof response != "boolean") {
                this.TableItems = response;
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    async DeleteStore(uuid) {
        sweetalert({
            title: "Are you sure?",
            text: "Do you want delete this store?",
            buttons: [this.$t("general.no"), this.$t("general.yes")],
        }).then(async (isConfirm) => {
            console.log("isConfirm", isConfirm);
            if (isConfirm == true) {
                const response = await ApiStores.DeleteStore(ApiEnter.CurrentSessionUUID, uuid);
                if (typeof response == "boolean") {
                    sweetalert({
                        title: this.$t("general.success"),
                        text: this.$t("general.success_deleted"),
                        icon: "success",
                    });
                    this.LoadTable();
                }
                else {
                    sweetalert({
                        title: this.$t("general.error"),
                        text: this.$t("general.request_error"),
                        icon: "info",
                    });
                }
            }
        });
    }
    FormatDate(date) {
        return dayjs.tz(date, "Europe/Rome").format("DD-MM-YYYY (HH:mm:s)");
    }
    created() {
        this.LoadTable();
    }
};
StoresList = __decorate([
    Component({
        components: { PageHeader, StandartTemplate, LeftMenuTab },
    })
], StoresList);
export default StoresList;
